/**
 * 루트 내비 — Home + 플랫폼 2축 (#291 → 최상위 랜딩 개편 2026-08-11).
 *
 * `/`(랜딩)는 VSMR 이중 정체성의 2택 관문이다: ① 저작·실행 플랫폼(Workspaces+
 * Simulations) vs ② 별도 운전 HMI(/operation-hmi/). 이 내비는 **① 플랫폼 세계
 * 안의** 루트 페이지(Overview·피커·시뮬레이션 관리)가 공유한다 — Home 은 랜딩
 * 복귀, Overview 는 플랫폼 최상위(이관 대시보드), 나머지 두 항목이 플랫폼 2축. ②는 별도 앱이라 이 내비에
 * 넣지 않고 랜딩을 경유한다.
 *
 * 메뉴 레벨 라벨은 영어로 통일한다(2026-08-07 결정) — 데이터 이름(예:
 * "기본 워크스페이스")은 시스템 용어가 아니므로 무관.
 */

import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import ListAltIcon from '@mui/icons-material/ListAlt';
import type { SidebarItem } from '@/app/chrome/Sidebar';

export type RootNavActive = 'overview' | 'workspaces' | 'simulations';

export function rootNavItems(
  active: RootNavActive,
  navigate: (path: string) => void,
): SidebarItem[] {
  return [
    {
      id: 'home',
      label: 'Home',
      icon: <HomeOutlinedIcon />,
      type: 'action',
      onClick: () => navigate('/'),
      selected: false, // 랜딩은 사이드바 밖 — 복귀 액션 전용
    },
    {
      id: 'overview',
      label: 'Overview',
      icon: <DashboardOutlinedIcon />,
      type: 'action',
      onClick: () => navigate('/platform'),
      selected: active === 'overview',
    },
    {
      id: 'workspaces',
      label: 'Workspaces',
      icon: <WorkspacesIcon />,
      type: 'action',
      onClick: () => navigate('/projects'),
      selected: active === 'workspaces',
    },
    {
      id: 'simulations',
      label: 'Simulations',
      icon: <ListAltIcon />,
      type: 'action',
      onClick: () => navigate('/simulations'),
      selected: active === 'simulations',
    },
  ];
}
